export const getSuccessfullyLoadedUrls = (images: string[]): Promise<string[]> => {
  const imagePromises: Promise<string>[] = images.map(image => new Promise(resolve => {
    const imageElement = new Image();

    imageElement.src = image;
    imageElement.onload = (): void => { resolve(image); };
    imageElement.onerror = (): void => { resolve(''); };
  }));

  return Promise
    .all(imagePromises)
    .then(images => images.filter(Boolean));
};
